import { mapActions } from 'vuex';

export default {
  created() {
    if (typeof window !== 'undefined') {
      this.startTrackingInterval();
      this._skGlobal.EVENTS.NATIVE.TAB.ACTIVATED.listen(this.startTrackingInterval);
      this._skGlobal.EVENTS.NATIVE.TAB.DEACTIVATED.listen(this.stopTrackingInterval);
    }
  },

  methods: {
    ...mapActions('onlineUsers', ['startTrackingInterval', 'stopTrackingInterval']),
  },

  beforeDestroy() {
    this._skGlobal.EVENTS.NATIVE.TAB.ACTIVATED.removeListener(this.startTrackingInterval);
    this._skGlobal.EVENTS.NATIVE.TAB.DEACTIVATED.removeListener(this.stopTrackingInterval);
  },
};
